import { useEffect, useState } from "react";
import axios from "axios";
import { NUGET_VERSIONS_ENDPOINT } from "../utils/config";
import { NugetVersions } from "../types";

export function useNugetVersions(): NugetVersions {
  const [versions, setVersions] = useState<NugetVersions>({});

  useEffect(() => {
    axios
      .get<NugetVersions>(NUGET_VERSIONS_ENDPOINT)
      .then((res) => setVersions(res.data))
      .catch(() => {});
  }, []);

  return versions;
}
